import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopupContainerComponent } from './popup-container.component';
import { PopupData } from './popup.models';

@Injectable({ providedIn: 'root' })
export class PopupService {
  private readonly dialog = inject(MatDialog);

  /**
   * Opens a popup dialog with the given configuration.
   * Returns a MatDialogRef whose afterClosed() emits the result.
   *
   * - For component content: pass `component` (and optional `componentInputs`).
   *   If the component has a `getValue()` method, confirm returns its value.
   * - For simple messages: pass `message` (and optional `icon`).
   * - Use `hideButtons: true` for info-only popups.
   * - Use `freeze: true` for non-dismissable popups (e.g. loading).
   */
  open<R = unknown>(
    config: PopupData,
  ): MatDialogRef<PopupContainerComponent, R> {
    return this.dialog.open<PopupContainerComponent, PopupData, R>(
      PopupContainerComponent,
      {
        data: config,
        width: config.width ?? '90%',
        maxWidth: config.maxWidth ?? '600px',
        disableClose: config.disableClose ?? config.freeze ?? false,
        hasBackdrop: true,
        panelClass: 'app-popup-panel',
        autoFocus: 'first-tabbable',
      },
    );
  }
}
